// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes blink {
	0% {
		opacity: 0;
	}

	100% {
		opacity: 1;
	}
}

@keyframes slideCoveringBlock {
	0% {
		transform: translate(0%, 0);
	}

	100% {
		transform: translate(100%, 0);
	}
}
.pnf-main-wrapper {
	display: flex;
	flex-direction: column;
	justify-content: center;
	text-align: center;
	width: 100vw;
	height: 100vh;
	background: black;
	overflow: hidden;
}

.pnf-wrapper {
	background-color: black;
	position: relative;
	max-width: 500px;
	align-self: center;
}

.pnf-covering-block {
	display: flex;
	align-items: center;
	height: 100%;
	width: 100%;
	position: absolute;
	background-color: black;
    transform: translate(100%, 0);
    animation: slideCoveringBlock 4s 1 ease-in-out;
}

.pnf-message {
	color: white;
	font-size: xxx-large;
}

.cursor {
	position: absolute;
	background-color: yellow;
	animation: blink 0.5s infinite;
	height: 50%;
	width: 35px;
}

.pnf-home-btn {
	align-self: center;
    animation: pulse 2s infinite;
    position: fixed;
    top: 515px;
    width: 100px;
    height: 50px;
    background-color: rgba(255, 255, 255, 0.2);
    color: white;
    border: 3px solid white;
    border-radius: 5%;
}`, "",{"version":3,"sources":["webpack://./src/components/pages/page-not-found/page-not-found.css"],"names":[],"mappings":"AAAA;CACC;EACC,UAAU;CACX;;CAEA;EACC,UAAU;CACX;AACD;;AAEA;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,6BAA6B;CAC9B;AACD;AACA;CACC,aAAa;CACb,sBAAsB;CACtB,uBAAuB;CACvB,kBAAkB;CAClB,YAAY;CACZ,aAAa;CACb,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;CACC,uBAAuB;CACvB,kBAAkB;CAClB,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,YAAY;CACZ,WAAW;CACX,kBAAkB;CAClB,uBAAuB;IACpB,6BAA6B;IAC7B,8CAA8C;AAClD;;AAEA;CACC,YAAY;CACZ,oBAAoB;AACrB;;AAEA;CACC,kBAAkB;CAClB,wBAAwB;CACxB,8BAA8B;CAC9B,WAAW;CACX,WAAW;AACZ;;AAEA;CACC,kBAAkB;IACf,4BAA4B;IAC5B,eAAe;IACf,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,0CAA0C;IAC1C,YAAY;IACZ,uBAAuB;IACvB,iBAAiB;AACrB","sourcesContent":["@keyframes blink {\n\t0% {\n\t\topacity: 0;\n\t}\n\n\t100% {\n\t\topacity: 1;\n\t}\n}\n\n@keyframes slideCoveringBlock {\n\t0% {\n\t\ttransform: translate(0%, 0);\n\t}\n\n\t100% {\n\t\ttransform: translate(100%, 0);\n\t}\n}\n.pnf-main-wrapper {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\ttext-align: center;\n\twidth: 100vw;\n\theight: 100vh;\n\tbackground: black;\n\toverflow: hidden;\n}\n\n.pnf-wrapper {\n\tbackground-color: black;\n\tposition: relative;\n\tmax-width: 500px;\n\talign-self: center;\n}\n\n.pnf-covering-block {\n\tdisplay: flex;\n\talign-items: center;\n\theight: 100%;\n\twidth: 100%;\n\tposition: absolute;\n\tbackground-color: black;\n    transform: translate(100%, 0);\n    animation: slideCoveringBlock 4s 1 ease-in-out;\n}\n\n.pnf-message {\n\tcolor: white;\n\tfont-size: xxx-large;\n}\n\n.cursor {\n\tposition: absolute;\n\tbackground-color: yellow;\n\tanimation: blink 0.5s infinite;\n\theight: 50%;\n\twidth: 35px;\n}\n\n.pnf-home-btn {\n\talign-self: center;\n    animation: pulse 2s infinite;\n    position: fixed;\n    top: 515px;\n    width: 100px;\n    height: 50px;\n    background-color: rgba(255, 255, 255, 0.2);\n    color: white;\n    border: 3px solid white;\n    border-radius: 5%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
